// extracted by mini-css-extract-plugin
export default {"button":"Button_button__pCr0n","buttonGold":"Button_buttonGold__oCL8E","buttonLight":"Button_buttonLight__60rQ5"};